import Styled from 'styled-components';

/* ul > div é HTML inválido; o browser “corrige” e o layout do CNJ quebra no mobile. */
export const LawsuitDetailRoot = Styled.div`
  width: 100%;
  min-width: 0;
  padding-left: 0;
  padding-right: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
`;

export const LinesContainer = Styled.div.attrs({ className: 'lawsuit-lines-container' })`
    width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    & > div {
        background-color: ${props => `${props.background} !important`}
    }

    @media (max-width: 800px) {
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) !important;
        gap: 10px;
        width: 100%;
        align-items: stretch;
    }
`;

export const LawsuitLine = Styled.div.attrs({ className: 'lawsuit-detail-line' })`
    width: 49.5%;
    min-width: 0;
    display: inline-flex;
    margin: .1rem 0;
    flex-direction: row;
    align-items: flex-start;
    color: #7f7f7f;
    padding: .25rem;
    font-size: 12px;

    @media (max-width: 800px) {
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) !important;
        row-gap: 6px;
        width: 100% !important;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;

        & > * {
            max-width: 100% !important;
            min-width: 0 !important;
            width: 100% !important;
            box-sizing: border-box;
        }

        & > div {
            display: flex;
            flex-direction: column;
            align-items: stretch;
            gap: 4px;
        }

        & .col,
        & [class*='col-'] {
            max-width: 100% !important;
            min-width: 0 !important;
            width: 100% !important;
        }

        & span.ignore-css-print {
            display: block;
            width: 100%;
            max-width: 100%;
            word-break: break-word;
            overflow-wrap: anywhere;
            line-height: 1.4;
        }
    }
`;